import React from "react";

const Note=(props)=>{
    const {title ,active, notesClicked}= props;
    return(
        <li className={`${active && 'active'}`} onClick={notesClicked} >{title}</li>
    )
}
export default Note;